import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/analytics-api.service';
import type { AnalyticsQueryParams, EngagementData } from '../types/analytics.types';

export const engagementKeys = {
  all: ['analytics', 'engagements'] as const,
  list: (params?: AnalyticsQueryParams) =>
    [...engagementKeys.all, 'list', params] as const,
};

export const useEngagementData = (params?: AnalyticsQueryParams, enabled = true) => {
  return useQuery({
    queryKey: engagementKeys.list(params),
    queryFn: async () => {
      const response = await analyticsApi.getEngagements(params);
      return response.data;
    },
    staleTime: 30 * 60 * 1000,
    enabled,
    select: (data: EngagementData) => ({
      total: data.total,
      monthOverMonthGrowth: data.monthOverMonthGrowth,
      previousPeriodTotal: data.previousPeriodTotal,
      trend: data.trend,
      byCategory: data.byCategory,
      byRegion: data.byRegion,
      byEngagementType: data.byEngagementType ?? [],
      uniqueInitiators: data.uniqueInitiators ?? 0,
      uniqueTargets: data.uniqueTargets ?? 0,
      growthLabel: formatGrowthLabel(data.monthOverMonthGrowth),
      isGrowthPositive: data.monthOverMonthGrowth >= 0,
    }),
  });
};

const formatGrowthLabel = (growth: number): string => {
  const sign = growth >= 0 ? '+' : '';
  return `${sign}${growth.toFixed(1)}% MoM`;
};
